import { API_LOCAL_BASE_URL } from "config";
import ReactPixel from "react-facebook-pixel";
import TiktokPixel from "tiktok-pixel";

export const fetchCart = async (
  cartToken,
  shopUrl,
  silentLoginToken,
  referral,
  rc,
  enrollType
) => {
  try {
    const apiUrl = `${API_LOCAL_BASE_URL}api/Checkout/FetchCart?cartToken=${cartToken}&shopUrl=${shopUrl}&silentLoginToken=${silentLoginToken}&referral=${referral}&rc=${rc}&enrollType=${enrollType}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(response);
    }
    return await response.json();
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const validateAddress = async (shopUrl, streetAddress, city, zip) => {
  try {
    const apiUrl = `${API_LOCAL_BASE_URL}api/Checkout/ValidateAddress?shopUrl=${shopUrl}&zip=${zip}&city=${city}&address=${streetAddress}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (response.ok && data.address) {
      return {
        success: true,
        address: data.address,
        city: data.city,
        state: data.state,
        zip: data.zip,
        country: data.country,
      };
    }

    throw new Error(data.message || "Invalid address");
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const recalculateCart = async (checkout) => {
  const apiUrl = `${API_LOCAL_BASE_URL}api/Checkout/CalculateCart`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        CartToken: checkout.cartToken,
        ShopUrl: checkout.shopUrl,
        CustomerToken: checkout.customerToken,
        SelectedShippingMethodId: checkout.cart.shipMethodID,
        DiscountRcID: checkout.cart.discountRcID,
        ReferralId: checkout.cart.referralId,
        ShippingAddress: shippingWrapper(checkout),
        Password: checkout.shipping.password,
        CustomerType: checkout.shopifyCustomer.customerTypeID
      }),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      console.error(
        "Failed to recalculate cart[shipment]:",
        response.statusText
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
  }
};

export const submitOrder = async (checkout, tokenization) => {
  const apiUrl = `${API_LOCAL_BASE_URL}api/Checkout/SubmitOrder`;
  try {
    const checkoutData = checkoutDetails(checkout, tokenization);

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(checkoutData),
    });

    // Facebook Pixel tracking
    ReactPixel.track("Purchase", {
      currency: checkout?.cart?.currency,
      value: checkout?.cart?.orderTotal,
    });

    // TikTok Pixel tracking
    TiktokPixel.track("CompletePayment", {
      currency: checkout?.cart?.currency,
      value: checkout?.cart?.orderTotal,
    });

    return response;
  } catch (error) {
    console.error("[API_DEBUG] submitOrder - Error caught:", error.message);
    throw error;
  }
};

export const validateAccount = async (account) => {
  const apiUrl = `${API_LOCAL_BASE_URL}api/Checkout/ValidateAccount`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ account }),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("Failed to validate address:", response);
    }
  } catch (error) {
    console.error("Error on validate address:", error.message);
    throw error;
  }
};

export const checkEmailExists = async (email, shopUrl) => {
  try {
    const response = await fetch(
      `${API_LOCAL_BASE_URL}api/Checkout/CheckEmailExists?email=${email}&shopUrl=${shopUrl}`
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const checkPhoneExists = async (phone, shopUrl) => {
  try {
    const response = await fetch(
      `${API_LOCAL_BASE_URL}api/Checkout/CheckPhoneExists?phone=${phone}&shopUrl=${shopUrl}`
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const IsWebaliasAvailable = async (webAlias, shopUrl) => {
  try {
    const response = await fetch(
      `${API_LOCAL_BASE_URL}api/Checkout/IsWebaliasAvailable?webAlias=${webAlias}&shopUrl=${shopUrl}`
    );
    const data = await response.json();

    if (data.isAvailable) {
      return {
        valid: "Username is available.",
        error: "",
        isLoading: false,
      };
    } else {
      return {
        valid: "",
        error: "Username is not available.",
        isLoading: false,
      };
    }
  } catch (error) {
    return {
      valid: "",
      error: "Error checking Username availability.",
      isLoading: false,
    };
  }
};

export const shippingWrapper = (checkout) => {
  let shipping = checkout.shipping.streetAddress
    ? checkout.shipping
    : checkout.newAddress;
  let wrapper = {};
  wrapper.city = shipping.city;
  wrapper.country = shipping.country;
  wrapper.state = shipping.state;
  wrapper.phone = shipping.phone;
  wrapper.email = shipping.email;
  wrapper.streetAddress = shipping.streetAddress;
  wrapper.address1 = shipping.streetAddress;
  wrapper.zip = shipping.zip;
  wrapper.SelectedShippingMethodID = "9";
  return wrapper;
}; //Test to get Deploy

export const checkoutDetails = (checkout, tokenization) => {
  const isEnrollingAsAmbassador = checkout.enrollType === "ambassador";
  const isEnrollingAsAffiliate = checkout.enrollType === "affiliate";
  const isAmbassadorOrAffiliate =
    isEnrollingAsAmbassador || isEnrollingAsAffiliate;
  let wrapper = {};

  wrapper.CartToken = checkout.cartToken;
  wrapper.ShopUrl = checkout.shopUrl;
  wrapper.CurrentStep = checkout.currentStep;
  wrapper.CustomerToken = checkout.customerToken;
  wrapper.ApplyPoints = checkout.applyPoints;
  wrapper.PriceTypeID = checkout.cart.priceTypeID;
  wrapper.DiscountRcID = checkout.cart.discountRcID;
  wrapper.PromoCode = checkout.promoCode || "";

  // Get firstName and lastName in order of priority
  wrapper.FirstName =
    checkout.shipping?.firstName ||
    checkout.shopifyCustomer?.firstName ||
    checkout.customer?.firstName ||
    "";
  wrapper.LastName =
    checkout.shipping?.lastName ||
    checkout.shopifyCustomer?.lastName ||
    checkout.customer?.lastName ||
    "";
  wrapper.EnrollerId = checkout.cart.referralId;

  // Email assignment with logging
  if (checkout.shipping.email) {
    wrapper.Email = checkout.shipping.email;
  } else if (checkout.shipping.loginEmail) {
    wrapper.Email = checkout.shipping.loginEmail;
  } else if (checkout.customer && checkout.customer.email) {
    wrapper.Email = checkout.customer.email;
  } else if (checkout.shopifyCustomer && checkout.shopifyCustomer.email) {
    wrapper.Email = checkout.shopifyCustomer.email;
  }

  wrapper.Webalias = checkout.customer?.webAlias;
  wrapper.Password = checkout.shipping.password;
  wrapper.UserName = isAmbassadorOrAffiliate
    ? checkout.shipping.username
    : checkout.shipping.loginEmail;
  wrapper.Phone = checkout.shipping.phone;
  wrapper.CustomerType = checkout.shopifyCustomer.customerTypeID;

  // BirthDate assignment for Ambassador only
  if (isEnrollingAsAmbassador) {
    const birthDateFromShipping = checkout.shipping?.birthDate;
    const birthDateFromNewAddress = checkout.newAddress?.birthDate;
    const birthDateFromCheckout = checkout.BirthDate;
    const birthDateFromStorage = localStorage.getItem("ambassador_birthdate");

    wrapper.BirthDate =
      birthDateFromShipping ||
      birthDateFromNewAddress ||
      birthDateFromCheckout ||
      birthDateFromStorage ||
      "";
  }

  //wrapper.Password = checkout.customer.password;
  wrapper.PrimaryPhone = checkout.customer?.phone;
  wrapper.ShippingAddressSameAsMain = checkout.sameShippingAddress;
  wrapper.BillingAddressSameAsMain = checkout.billingAddress.sameAsShipping;
  wrapper.AddressValidatedManually = checkout.addressValidatedManually || false;
  wrapper.PaymentMethod = checkout.creditcard;
  
  if (checkout.creditcard.isSavedCard) {
    wrapper.PaymentMethod.Token = checkout.creditcard.savedCardToken || "";
    wrapper.PaymentMethod.PaymentMethodName = "SavedCard";
    wrapper.PaymentMethod.IsSavedCard = true;
    wrapper.PaymentMethod.UseSavedCard = true;
  } else {
    const tokenString = typeof tokenization.token === 'object' ? tokenization.token.token : tokenization.token;
    wrapper.PaymentMethod.Token = tokenString || "";
    wrapper.PaymentMethod.PaymentMethodName = tokenization.cardType || "";
    wrapper.PaymentMethod.IsSavedCard = false;
    wrapper.PaymentMethod.UseSavedCard = false;
  }
  
  const expirationMonth = parseInt(checkout.creditcard.expirationMonth, 10);
  const expirationYear = parseInt(checkout.creditcard.expirationYear, 10);
  
  wrapper.PaymentMethod.ExpirationMonth = expirationMonth;
  wrapper.PaymentMethod.ExpirationYear = expirationYear;
  wrapper.SaveCreditCard = checkout.SaveCreditCard;
  wrapper.IsGuestCheckout = !checkout.customerToken && !checkout.shipping?.password && !checkout.shipping?.loginEmail;

  wrapper.MainAddress = {
    /* ... */
  };
  wrapper.ShippingAddress = checkout.shipping;
  wrapper.ShippingAddress.address1 = checkout.shipping.streetAddress;
  if (checkout.billingAddress.sameAsShipping) {
    wrapper.BillingAddress = checkout.shipping;
  } else {
    wrapper.BillingAddress = checkout.billingAddress;
  }
  wrapper.BillingAddress.SameAsShipping =
    checkout.billingAddress.sameAsShipping;
  wrapper.SelectedShippingMethodID = "9";

  if (checkout.subscription.startDate !== "") {
    wrapper.Subscription = checkout.subscription;
  }

  return wrapper;
};

export const getSavedCreditCard = async (shopUrl, customerToken) => {
  try {
    const apiUrl = `${API_LOCAL_BASE_URL}api/Customer/GetSavedCreditCard?shopUrl=${shopUrl}&customerToken=${customerToken}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching saved credit card:", error);
    return {
      success: true,
      message: "No saved credit card found",
      savedCard: null
    };
  }
};

export const validatePromoCode = async (promoCode, shopUrl, shippingAddress = null, cartToken = null, customerTypeId) => {
  try {
    const apiUrl = `${API_LOCAL_BASE_URL}api/Checkout/ValidatePromoCode`;

    const requestBody = {
      PromoCode: promoCode,
      ShopUrl: shopUrl,
      CartToken: cartToken,
      Country: shippingAddress.country,
      State: shippingAddress.state,
      City: shippingAddress.city,
      Zip: shippingAddress.zip,
      Address1: shippingAddress.streetAddress || shippingAddress.address1 || "Default Address",
      CustomerTypeID: customerTypeId
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error("Failed to validate promo code");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error validating promo code:", error);
    throw error;
  }
};

export const upgradeToAmbassador = async (
  exigoCustomerId,
  shopUrl,
  birthDate
) => {
  try {
    const apiUrl = `${API_LOCAL_BASE_URL}api/Customer/UpgradeToAmbassadorV2?exigoCustomerId=${exigoCustomerId}&shopUrl=${shopUrl}&birthDate=${birthDate}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      let errorMessage = "Upgrade failed: " + response.statusText;
      try {
        const errorData = await response.json();
        if (errorData && errorData.message) {
          errorMessage += " - " + errorData.message;
        }
      } catch (jsonError) {
        // If we can't parse JSON, try to get the text
        try {
          const errorText = await response.text();
          if (errorText) {
            errorMessage += " - " + errorText;
          }
        } catch (textError) {
          // If we can't get text either, just use the status
          console.error("Could not parse error response:", textError);
        }
      }
      throw new Error(errorMessage);
    }

    return true;
  } catch (error) {
    console.error("Error upgrading to Ambassador:", error);
    throw error;
  }
};
